import {Box, Button, Columns, Column, Stack, Text} from "@unibuddy/patron";
import React from "react";
import {useTranslation} from "@unibuddy/intl";
import PropTypes from "prop-types";
import WarningIconWithOutline from "shared/Experimental/Icons/WarningIconWithOutline";
import {IntlNamespaces} from "../../../../../translations/types";
import {INTL_TO_PROTECT_DELINKED_PRIVACY} from "../../../../../translations/inbox";
import {isFunction} from "../../../../../util/isFunction";

const DelinkedMessage = (props) => {
    const {t} = useTranslation(IntlNamespaces.INBOX);
    const universityName = props.universityName || "your university";

    return (
        <Box bgColor="#dfedf7" padding={"medium"} data-test-id="delinked-banner">
            <Stack space={"small"}>
                <Columns space={"small"}>
                    <Column width="content">
                        <WarningIconWithOutline />
                    </Column>
                    <Column>
                        <Text color="#404446">
                            {t(
                                INTL_TO_PROTECT_DELINKED_PRIVACY.key,
                                isFunction(INTL_TO_PROTECT_DELINKED_PRIVACY.defaultValue)
                                    ? INTL_TO_PROTECT_DELINKED_PRIVACY.defaultValue(universityName)
                                    : INTL_TO_PROTECT_DELINKED_PRIVACY.defaultValue,

                                {universityName},
                            )}
                        </Text>
                    </Column>
                </Columns>
                <Button block color="primary" onClick={props.redirectToRelink}>
                    {t("startChattingAgainBtn", `Get chatting again!`, {
                        universityName,
                    })}
                </Button>
            </Stack>
        </Box>
    );
};

DelinkedMessage.propTypes = {
    universityName: PropTypes.string,
    redirectToRelink: PropTypes.func.isRequired,
};

DelinkedMessage.defaultProps = {
    universityName: "your university",
};

export default DelinkedMessage;
